import { ROLES_WITH_ADMIN_CAPABILITIES } from "@stadium/constants/lib/contacts";

export const isAdminOrOwner = (roles) =>
  roles.some((role) => ROLES_WITH_ADMIN_CAPABILITIES.includes(role));
